import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';

//do not remove !!!
import styles from '../sass/main.scss';

window.UIkit = UIkit;

UIkit.use(Icons);


UIkit.icon.add({
    'user': '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.625 5C5.625 6.16032 6.08594 7.27312 6.90641 8.09359C7.72688 8.91406 8.83968 9.375 10 9.375C11.1603 9.375 12.2731 8.91406 13.0936 8.09359C13.9141 7.27312 14.375 6.16032 14.375 5C14.375 3.83968 13.9141 2.72688 13.0936 1.90641C12.2731 1.08594 11.1603 0.625 10 0.625C8.83968 0.625 7.72688 1.08594 6.90641 1.90641C6.08594 2.72688 5.625 3.83968 5.625 5V5Z" stroke="#000" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/><path d="M1.875 19.375C1.875 17.2201 2.73102 15.1535 4.25476 13.6298C5.77849 12.106 7.84512 11.25 10 11.25C12.1549 11.25 14.2215 12.106 15.7452 13.6298C17.269 15.1535 18.125 17.2201 18.125 19.375" stroke="#000" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg>'
})
